import type { MessageDescriptor } from 'react-intl';
import { taxHintMessages } from '../messages';

export function getTaxHintMessage(
  type: 'TITLE' | 'TEXT',
  deliveryType: 'DEFAULT' | 'S' | 'L',
): MessageDescriptor {
  switch (type) {
    case 'TITLE': {
      switch (deliveryType) {
        case 'L':
          return taxHintMessages.titleL;
        case 'S':
          return taxHintMessages.titleS;
        default:
          return taxHintMessages.titleDEFAULT;
      }
    }
    case 'TEXT': {
      switch (deliveryType) {
        case 'L':
          return taxHintMessages.carrierDeliveryL;
        case 'S':
          return taxHintMessages.carrierDeliveryS;
        default:
          return taxHintMessages.carrierDeliveryDEFAULT;
      }
    }
    default:
      throw new Error('Method getTaxHintMessage has been called with an invalid type!');
  }
}
